module.exports = __webpack_public_path__ + "img/cover258.730d2ac8.png";